import { ShipmentsStore } from "./shipments/shipments.store";
import { UserPreferencesStore } from "./user-preferences/user-preferences.store";

export function provideSignalStore() {
  return [ShipmentsStore, UserPreferencesStore]
}